export const baseURL =  `${window.location.origin}/v1/`; // "https://hrmsnow.staging.rigoerp.com/v1/"; // `https://localhost:44300/v1/`;
//